<template>
<el-popover placement="bottom-start" width="310" trigger="click" :value="visible" @show="visible = true">
    <el-form :model="filterForm" ref="filterForm">
        <el-form-item size="small" prop="dateRange" label="Date Range">
            <el-date-picker v-model="filterForm.dateRange" format="MM/dd/yyyy" value-format="MM/dd/yyyy" type="daterange" range-separator="-" start-placeholder="Start date" end-placeholder="End date" style="width:100%;">
            </el-date-picker>
        </el-form-item>

        <el-form-item size="small" prop="userName" label="User">
            <el-select v-model="filterForm.userName" placeholder="User" style="width:100%;">
                <el-option v-for="(user, index) in userRecords" :key="index" :label="user" :value="user"></el-option>
            </el-select>
        </el-form-item>

        <el-form-item size="small" prop="status" label="Status">
            <el-select v-model="filterForm.status" placeholder="Status" style="width:100%;">
                <el-option v-for="(status, index) in statusRecords" :key="index" :label="status.label" :value="status.value"></el-option>
            </el-select>
        </el-form-item>

        <el-form-item>
            <el-button size="small" type="danger" plain @click="handleClearFilter">Clear</el-button>
            <div style="float: right;">
                <el-button size="small" type="primary" @click="handleFilter" style="width:8em">Filter</el-button>
            </div>
        </el-form-item>
    </el-form>
    <el-button size="small" type="primary" slot="reference" icon="mdi mdi-filter-menu"> Filter</el-button>
</el-popover>
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex';
import * as type from '@/store/types';
import {
    bus
} from '@/main';
export default {
    data() {
        return {
            visible: false,
            filterForm: {
                dateRange: '',
                userName: '',
                status: ''
            }
        }
    },
    computed: {
        ...mapGetters({
            userRecords: 'quickbooklogs/userRecords',
            statusRecords: 'quickbooklogs/statusRecords',
        })
    },
    created() {
        bus.$on('clearUploadHistoryFilter', this.handleClearFilter)
        this.loadUserRecords();
        this.loadStatusRecords();
    },
    methods: {
        ...mapActions({
            loadUserRecords: `quickbooklogs/${type.GET_USER_RECORDS}`,
            loadStatusRecords: `quickbooklogs/${type.GET_STATUS_RECORDS}`,
            loadQBLogs: `quickbooklogs/${type.QB_GET_LOGS}`
        }),
        handleFilter() {
            let startDate = this.filterForm.dateRange[0]
            let endDate = this.filterForm.dateRange[1]
            let {
                userName,
                status
            } = this.filterForm;

            this.loadQBLogs({
                startDate,
                endDate,
                userName,
                status
            })
            this.visible = false;
        },
        handleClearFilter() {
            this.$refs.filterForm.resetFields();
            this.loadQBLogs({})
            this.visible = false;
        }
    }
}
</script>
